import './HomeScreen.css';

export default function HomeScreen({ slugStatus }) {
  // Se ainda está verificando, mostra loading
  if (slugStatus === null) {
    return (
      <div className="home-screen">
        <p>Carregando...</p>
      </div>
    );
  }

  // Se não houver slug na URL ou se tiver slug mas não encontrou a sala,
  // mostra apenas mensagem amigável sem botões (por segurança)
  if (slugStatus === 'no-slug' || slugStatus === 'not-found') {
    const message = slugStatus === 'no-slug'
      ? 'Por favor, acesse a sala através do link fornecido.'
      : 'O link da sala não foi encontrado. Por favor, verifique o link e tente novamente.';

    return (
      <div className="home-screen">
        <h1>Link inválido</h1>
        <p>{message}</p>
      </div>
    );
  }

  // Se tem slug e encontrou a sala, não deveria chegar aqui
  // (deveria estar em STATE_HAIRCHECK ou STATE_JOINED)
  // Mas por segurança, mostra mensagem de carregamento
  if (slugStatus === 'found') {
    return (
      <div className="home-screen">
        <h1>Carregando sala...</h1>
        <p>Aguarde enquanto preparamos sua sala.</p>
      </div>
    );
  }

  // Caso padrão: não deveria chegar aqui
  return null;
}
